//#region src/api/logs/const.ts
const defaultLogArgsSerializer = (args) => args.map((arg) => {
	try {
		return String(arg);
	} catch (_err) {
		return "";
	}
}).join(" ");
//#endregion
export { defaultLogArgsSerializer };

//# sourceMappingURL=const.js.map